import {
    Button,
    Box,
    Typography,
} from '@mui/material';
import Table from '@mui/material/Table';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import MobileStepper from '@mui/material/MobileStepper';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useEffect, useState } from 'react';
import { SelectGenericFromTable, SelectRowFromTable } from '../universal/Axios';
import { GenAlgGenerationTable } from './GenAlgGenerationTable';
import { GenAlgIndividualTable } from './GenAlgIndividualTable';
import apiClient from '../../apiClient';
import { HandleAuthError, GenericStackTraceValidator } from '../universal/Alert';
import { getStore } from '../../Store'
import { useTheme } from '@mui/material/styles';
import { Switch } from '@mui/material';

const store = getStore();

const EditGenAlgRun = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")
    const [genAlgRunObject, setGenAlgRunObject] = useState([])
    const [baselineIndividualObject, setBaselineIndividualObject] = useState([])
    const [activeStep, setActiveStep] = useState(0);
    const [baseParameterValues, setBaseParameterValues] = useState([])
    const [genAlgRunObjectUpdateTrigger, setGenAlgRunObjectUpdateTrigger] = useState(false)

    const theme = useTheme();

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleAutoRunToggle = () => {
        store.updateStatusMessage("Toggling Auto Run")
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Toggle_Gen_Alg_Run_Auto_Run",
                "gen_alg_run_id": id,
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully toggled Auto Run!")
            setGenAlgRunObjectUpdateTrigger(!genAlgRunObjectUpdateTrigger)
        })
    }

    const handleGenAlgRun = () => {
        store.updateStatusMessage("Triggering Genetic Algorithm Run...")
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Handle_Genetic_Algorithm_Run",
                "gen_alg_run_id": id,
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully triggered Genetic Algorithm Run!")
        }).catch(function (error) {
            console.log(error)
            if (error?.response?.status === 401) {
                HandleAuthError()
            } else {
                console.log(error?.response?.data)
                const stackTraceMessage = GenericStackTraceValidator(error?.response?.data, "Gen Alg Run")
                if (stackTraceMessage != null) {
                    store.updateErrorMessage(stackTraceMessage)
                } else {
                    store.updateErrorMessage("Error while triggering Genetic Algorithm Run")
                }
            }
        })
    }
    const generateVisualizations = () => {
        store.updateStatusMessage("Generating Gen Alg Visualizations...")
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Generate_Genetic_Algorithm_Visualizations",
                "gen_alg_run_id": id,
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully generated Genetic Algorithm Run visualizations!")
        }).catch(function (error) {
            console.log(error)
            if (error?.response?.status === 401) {
                HandleAuthError()
            } else {
                console.log(error?.response?.data)
                const stackTraceMessage = GenericStackTraceValidator(error?.response?.data, "Gen Alg Run")
                if (stackTraceMessage != null) {
                    store.updateErrorMessage(stackTraceMessage)
                } else {
                    store.updateErrorMessage("Error while triggering Genetic Algorithm Run")
                }
            }
        })
    }

    useEffect(() => {
        SelectRowFromTable("select gar.*, psc.parameter_set_id from gen_alg_run gar JOIN parameter_set_config psc ON psc.id = gar.base_parameter_set_config_id where gar.id = '" + id + "';", setGenAlgRunObject)
        SelectGenericFromTable("select gar.id, dppscm.dnc_param_id, dppscm.value from gen_alg_run gar join dnc_param_parameter_set_config_mapping dppscm on dppscm.parameter_set_config_id = gar.base_parameter_set_config_id WHERE gar.id = '" + id + "';", setBaseParameterValues)
    }, [genAlgRunObjectUpdateTrigger]);

    useEffect(() => {
        if (genAlgRunObject != null && genAlgRunObject.base_parameter_set_config_id != null) {
            SelectRowFromTable("SELECT * FROM gen_alg_individual gai JOIN gen_alg_generation gag on gag.id = gai.gen_alg_generation_id WHERE gen_alg_run_id = '" + id + "' AND parameter_set_config_id = '" + genAlgRunObject.base_parameter_set_config_id + "';", setBaselineIndividualObject)
        }
    }, [genAlgRunObject])

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box>
                    <Typography variant="h6">Gen Alg Run: <b>{id}</b></Typography>
                </Box>
            </Box>
            <Switch checked={genAlgRunObject.is_auto_run} onChange={handleAutoRunToggle} /> Auto Run
            <Box sx={{ float: "right", marginTop: "15px" }}>
                <Button
                    variant="contained"
                    href={"gen-alg-runs"}
                >
                    BACK
                </Button>
                <a href={"/gen-alg-analytics-files?gen-alg-run-id=" + id} target="_blank">
                    <Button
                        variant="contained"
                        sx={{ marginLeft: '20px' }}
                    >
                        View Visualizations
                    </Button>
                </a>
                <Button
                    variant="contained"
                    sx={{ marginLeft: '20px' }}
                    onClick={() => generateVisualizations(id)}
                >
                    Generate Visualizations
                </Button>
                <Button
                    variant="contained"
                    sx={{ marginLeft: '20px' }}
                    onClick={() => handleGenAlgRun(id)}
                >
                    Trigger Gen Alg Run
                </Button>
            </Box>
            <Box sx={{ marginTop: '20px', marginLeft: '10px', fontSize: '20px', height: '50px' }}>
            </Box>  
            <Box sx={{ height: '300px' }}>
                {activeStep == 0 && <>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{<b>Status</b>}</TableCell>
                                    <TableCell>{<b>Base DNC</b>}</TableCell>
                                    <TableCell>{<b>Selection Config</b>}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{genAlgRunObject.status}</TableCell>
                                    <TableCell>{<a
                                        href={'edit-density-network-config?id=' + genAlgRunObject.base_dnc_id}
                                        target="_blank"
                                    >
                                        {genAlgRunObject.base_dnc_id}
                                    </a>}</TableCell>
                                    <TableCell>{<a
                                        href={'create-gen-alg-selection-config?id=' + genAlgRunObject.gen_alg_selection_config_id}
                                        target="_blank"
                                    >
                                        {genAlgRunObject.gen_alg_selection_config_id}
                                    </a>}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{<b>Comparative Set</b>}</TableCell>
                                    <TableCell>{<b>Baseline Median SI-SDR</b>}</TableCell>
                                    <TableCell colSpan={2}>{<b>Persister Config</b>}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{<a
                                        href={'edit-comparative-set?id=' + genAlgRunObject.partial_comparative_set_id}
                                        target="_blank"
                                    >
                                        {genAlgRunObject.partial_comparative_set_id}
                                    </a>}</TableCell>
                                    <TableCell>{baselineIndividualObject.median_si_sdr}</TableCell>
                                    <TableCell colSpan={2}>{<a
                                        href={'edit-persister-config?id=' + genAlgRunObject.persister_config_id}
                                        target="_blank"
                                    >
                                        {genAlgRunObject.persister_config_id}
                                    </a>}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={100}>{<><b>Description:</b> {genAlgRunObject.description}</>}</TableCell>
                                </TableRow>
                            </TableHead>
                        </Table>
                    </TableContainer>
                </>
                }
                {activeStep == 1 && <>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{<b>Current Generation</b>}</TableCell>
                                    <TableCell>{<b>Max Generation</b>}</TableCell>
                                    <TableCell>{<b>Parameter Set</b>}</TableCell>
                                    <TableCell>{<b>Created Date</b>}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{genAlgRunObject.current_generation_number}</TableCell>
                                    <TableCell>{genAlgRunObject.max_generation_count}</TableCell>
                                    <TableCell>{<a
                                        href={'edit-parameter-set?id=' + genAlgRunObject.parameter_set_id}
                                        target="_blank"
                                    >
                                        {genAlgRunObject.parameter_set_id}
                                    </a>}</TableCell>
                                    <TableCell>{genAlgRunObject.created_date}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{<b>Individuals Per Generation</b>}</TableCell>
                                    <TableCell>{<b>Auto Run</b>}</TableCell>
                                    <TableCell colSpan={2}>{<b>Default Parameter Values</b>}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{genAlgRunObject.max_individuals_per_generation}</TableCell>
                                    <TableCell>{genAlgRunObject.is_auto_run ? "True" : "False"}</TableCell>
                                    <TableCell colSpan={2}>{baseParameterValues.map(x => x.dnc_param_id + ": " + x.value).join('; ')}</TableCell>
                                </TableRow>
                            </TableHead>
                        </Table>
                    </TableContainer>
                </>}
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", margin: '30px', fontSize: '20px' }}>
            <MobileStepper
                variant="dots"
                steps={2}
                position="static"
                activeStep={activeStep}
                sx={{ maxWidth: 400, flexGrow: 1 }}
                nextButton={
                    <Button size="small" onClick={handleNext} disabled={activeStep === 1}>
                        Next
                        {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft />
                        ) : (
                            <KeyboardArrowRight />
                        )}
                    </Button>
                }
                backButton={
                    <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                        {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight />
                        ) : (
                            <KeyboardArrowLeft />
                        )}
                        Back
                    </Button>
                }
                />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", margin: '30px', fontSize: '20px' }}>
                <b>Generations:</b>
            </Box>
            <div style={{ height: 400, width: '100%' }}>
                <GenAlgGenerationTable parent_id={id} />
            </div>
            <Box sx={{ display: "flex", justifyContent: "center", margin: '30px', fontSize: '20px' }}>
                <b>All Individuals:</b>
            </Box>
            <div style={{ height: 800, width: '100%' }}>
                <GenAlgIndividualTable gen_alg_run_id={id} />
            </div>
        </Box>
    )
}

export default EditGenAlgRun